export const environment = {
  production: false,
  BB_TICKET_SERVICE_URL: "https://bbgateway.service.bb.area1.eurofins.local/api/bbticket/",
  BB_MDMSERVICE_URL: "https://apigatewayd.eurofinsgenomics.eu/prod-bbmdm-animal/",
  BB_APIGATEWAY_SERVICE_URL: "https://apigatewayd.eurofinsgenomics.eu/bbgateway/",
  BB_APG_SAMPLE_PROCESSING_URL: "https://apigatewayd.eurofinsgenomics.eu/prod-animal-sampleprocessing/",
  BB_ANIMAL_ORDER_SERVICE_URL: "https://apigatewayd.eurofinsgenomics.eu/prod-bbanimal-orderservice/",
  BB_APG_NC_HANDLING_URL: "https://apigatewayd.eurofinsgenomics.eu/prod-animal-handlingprocess/",
  BB_SAMPLE_RECEPTION_SERVICE_URL: "",
  BB_PRINT_SERVICE_URL: "https://apigatewayd.eurofinsgenomics.eu/bbprint/",
  BB_QC_SAMPLE_SERVICE_URL: "",
  BB_SWAB_SAMPLE_RECEPTION_SERVICE_URL: "",
  BB_MARVELMESSAGING_SERVICE_URL: "",
  BB_ORDERRECEPTION_SERVICE_URL: "",
  BB_DMS_SERVICE_URL: "",
  BB_SEQUENCING_SERVICE_URL: "",
  BB_SHIPMENT_SERVICE_URL: "",
  BB_ORDER_CREATION_SCHEDULER_URL: "",
  BB_MAIL_RECEPTION_URL: "",
  BB_NGS_ENTRY_QC_URL: "",
  BB_NGS_LIB_PREP_URL: "",
  BB_QC_REPORT_MANAGEMENT_URL: "",
  BB_STORAGE_URL: "https://bbgateway.service.bb.area1.eurofins.local/api/bbstorage/",
  BB_NON_PREMIX_DATA_DELIVERY: '',
  AZURE_AUTHORIZATION_URL: "https://login.microsoftonline.com/1fbb4ba6-ea05-4146-a51e-8eab1e5605f0/oauth2/v2.0/authorize",
  AZURE_TOKEN_URL: "https://login.microsoftonline.com/1fbb4ba6-ea05-4146-a51e-8eab1e5605f0/oauth2/v2.0/token",
  AZURE_LOGOUT_URL: "https://login.microsoftonline.com/1fbb4ba6-ea05-4146-a51e-8eab1e5605f0/oauth2/v2.0/logout",
  AZURE_TENANT_ID: "1fbb4ba6-ea05-4146-a51e-8eab1e5605f0",
  AZURE_BBUI_CLIENT_ID: "829544f3-b564-463e-bb2c-e2838c3bbb38",
  AZURE_BBUI_REDIRECT_URL_AFTER_LOGIN: "https://apg.eurofinsgenomics.eu/",
  AZURE_MDM_GROUP_ID: 'BlueberryAdmin',
  AZURE_SANGER_GROUP_CLAIM: 'MDM-ADMIN-GROUP',
  AZURE_APG_GROUP_CLAIM: 'APG-LAB-GROUP',
  AZURE_GenoTyping_Aarhus_GROUP_CLAIM: 'BlueberryGenoTypingAarhusLabUsers',
  AZURE_NGS_Konstanz_GROUP_CLAIM: 'BlueberryNGSKonstanzLabUsers',
  AZURE_APG_Ebersberg_GROUP_CLAIM: 'BlueberryAPGEbersbergLabUsers',
  AZURE_Sanger_Cologne_CLAIM: 'BlueberrySangerCologneLabUsers',
  AZURE_Sanger_Ebersberg_CLAIM: 'BlueberrySangerEbersbergLabUsers',
  AZURE_APG_Denmark_GROUP_CLAIM: 'BlueberryAPGDenmarkLabUsers',
  AZURE_APG_Training_GROUP_CLAIM:'BlueberryAPGTrainingLabUsers',
  AZURE_APG_NETHERLANDS_GROUP_CLAIM: 'BlueberryAPGNederlandLabUsers',
  AZURE_APG_CPH_PCR_GROUP_CLAIM: 'BlueberryAPGCopenhagenLabUsers',
  AZURE_APG_COLOGNE_GROUP_CLAIM: 'BlueberryAPGCologeneLabUsers',
  AZURE_APG_SWEDEN_GROUP_CLAIM:'BlueberryAPGSwedenUppsalaLabUsers',
  AZURE_APG_TEDDINGTON_GROUP_CLAIM:'BlueberryAPGUK-TeddingtonLabUsers',
  AZURE_AUTHORIZATION_SCOPE: "api://21770d69-3274-4187-abc2-23a9eb1b27b3/bbanimal.access",
  AZURE_LOGIN_NEEDED: true,
  AZURE_APPINSIGHTS_INSTRUMENTATIONKEY: "e1891dd0-5028-40b8-97f6-d28b2e599384",
  AZURE_APG_ANIMAL_GROUP_CLAIM: 'BlueberryAPGAnimalLabUsers',
  //This is the timeout used by frontEnd services.This is in milli seconds.
  defaultTimeout:11000
};
